<div class="padding-top" [formGroup]="formularzUszkodzenia">
    <label class="c-label">
        <textarea id="komentarz" rows="5" formControlName="komentarz" class="c-input" placeholder="Wpisz nazwę przedmiotu i jego wartość"></textarea>
        <span *ngIf="formularzUszkodzenia?.controls.komentarz.errors && (formularzUszkodzenia?.controls.komentarz.touched || formularzUszkodzenia?.controls.komentarz.dirty)"
            class="c-label__title text-danger u-margin-right-tiny">Ta informacja jest obowiązkowa</span>
    </label>
</div>
